import { ErrorBoundary, HomeWidget, componentError } from "@portal/arq-portal-core"
import React from "react"
import { Software } from "./Software";

export const WrappedSoftware = (props:any) => {    
    return (
        <ErrorBoundary 
            fallback={()=>{
                return <HomeWidget titulo={componentError.title} error={componentError.body}></HomeWidget>
            }}
        >
                <Software {...props} />
        </ErrorBoundary>
    )
}